import React from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// import required modules
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

import '../Review/Review.css'

const Review = () => {
  return (
    <>
      <div className='main-review'>
        <div className="ribbon4" data-aos="fade-left">Our client's Say</div>
        <Swiper
          spaceBetween={30}
          centeredSlides={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          navigation={true}
          modules={[Autoplay, Pagination, Navigation]}
          className="mySwiper"
        >
          <SwiperSlide>
            <div className='box-main'>
              <div className="testimonial-box">
                <div className="box-top">
                  <div className="profile">
                    <div className="profile-img">
                      <img src="https://cdn3.iconfinder.com/data/icons/avatars-15/64/_Ninja-2-512.png" alt="patient" />
                    </div>
                    <div className="name-user">
                      <strong>Ravi Sharma</strong>
                      <span>@ravisharma</span>
                    </div>
                  </div>
                  <div className="reviews">
                    <i className="fas fa-star" />
                    <i className="fas fa-star" />
                    <i className="fas fa-star" />
                    <i className="fas fa-star" />
                    <i className="far fa-star" />
                  </div>
                </div>
                <div className="client-comment">
                  <p>The doctors here are very professional and caring. I felt comfortable throughout my treatment and the staff ensured everything went smoothly.</p>
                </div>
              </div>

              <div className="testimonial-box">
                <div className="box-top">
                  <div className="profile">
                    <div className="profile-img">
                      <img src="https://cdn3.iconfinder.com/data/icons/avatars-15/64/_Ninja-2-512.png" alt="patient" />
                    </div>
                    <div className="name-user">
                      <strong>Priya Verma</strong>
                      <span>@priyaverma</span>
                    </div>
                  </div>
                  <div className="reviews">
                    <i className="fas fa-star" />
                    <i className="fas fa-star" />
                    <i className="fas fa-star" />
                    <i className="fas fa-star" />
                    <i className="fas fa-star" />
                  </div>
                </div>
                <div className="client-comment">
                  <p>I received excellent care from the medical team. The facilities are modern and the staff is very supportive. Highly recommend this agency!</p>
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className='box-main'>
              <div className="testimonial-box">
                <div className="box-top">
                  <div className="profile">
                    <div className="profile-img">
                      <img src="https://cdn3.iconfinder.com/data/icons/avatars-15/64/_Ninja-2-512.png" alt="patient" />
                    </div>
                    <div className="name-user">
                      <strong>Ankit Mehra</strong>
                      <span>@ankitmehra</span>
                    </div>
                  </div>
                  <div className="reviews">
                    <i className="fas fa-star" />
                    <i className="fas fa-star" />
                    <i className="fas fa-star" />
                    <i className="fas fa-star" />
                    <i className="far fa-star" />
                  </div>
                </div>
                <div className="client-comment">
                  <p>The agency provided me with quick medical assistance in an emergency. Very grateful for their timely and efficient service.</p>
                </div>
              </div>

              <div className="testimonial-box">
                <div className="box-top">
                  <div className="profile">
                    <div className="profile-img">
                      <img src="https://cdn3.iconfinder.com/data/icons/avatars-15/64/_Ninja-2-512.png" alt="patient" />
                    </div>
                    <div className="name-user">
                      <strong>Neha Gupta</strong>
                      <span>@nehagupta</span>
                    </div>
                  </div>
                  <div className="reviews">
                    <i className="fas fa-star" />
                    <i className="fas fa-star" />
                    <i className="fas fa-star" />
                    <i className="fas fa-star" />
                    <i className="far fa-star" />
                  </div>
                </div>
                <div className="client-comment">
                  <p>Very professional and empathetic doctors. They guided me at every step and made my recovery process smooth and stress-free.</p>
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </>
  )
}

export default Review;
